import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { planPrice } from "./subscriptionDetails";

export default function PlanAction({ plan, activePlan, currency, statusUnavailable }) {
	const current = activePlan && String(activePlan.id) === String(plan.id);
	const unavailable = current ? "Your current plan" : activePlan ? "Available after current plan"
		: statusUnavailable ? "Check subscription status first"
			: planPrice(plan, currency) === null ? "Unavailable in this currency" : null;

	return unavailable ? (
		<button type="button" className="plans-button" disabled>{unavailable}</button>
	) : (
		<Link className="plans-button" to={`/subscription/pay/${plan.id}`} aria-label={`Choose ${plan.name} plan`}>
			Choose {plan.name}<FiArrowRight aria-hidden="true" />
		</Link>
	);
}
